
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__hide/[faqPage]",
      function () {
        return require("private-next-pages/__hide/[faqPage].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__hide/[faqPage]"])
      });
    }
  